import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Detail from '../views/Detail'
import PageError from '../views/PageError'
import Favorite from '../views/Favorite'
import About from '../views/About'

Vue.use(VueRouter)

function requireAuth(route, redirect, next) {
  if (!!localStorage.getItem('token')) {
    next()
  } else {
    router.push({ path: '/' })
  }
}



const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,

  },
  {
    path: '/flat-detail/:id',
    name: 'flat-detail',
    component: Detail,
  },
  {
    path: '/add-advertisement',
    name: 'advertisement',
    redirect: '/add-advertisement/step1',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Advertisement.vue'),
    children: [
      {
        path: 'step1',
        name: 'step1',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/advertisement/Step1.vue'
          ),
      },
      {
        path: 'step2',
        name: 'step2',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/advertisement/Step2.vue'
          ),
      },
      {
        path: 'step3',
        name: 'step3',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/advertisement/Step3.vue'
          ),
      },
    ],
  },
  {
    path: '/favorite',
    name: 'favorite',
    component: Favorite,
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: About,

  },
  {
    path: '*',
    name: '404-page',
    component: PageError,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (!savedPosition)return { x: 0, y: 0 }
    return savedPosition
  },



})


export default router
